import React from 'react';
import './WhyChoose.scss';

const WhyChoose = ({ whyChooseContent = {} }) => {
  return (
    <section className="whychoose">
      <div className="whychoose__container">
        <h2 className="whychoose__title">{whyChooseContent.title}</h2>
        <div className="whychoose__content">
          <div className="whychoose__image-wrapper">
            <img
              src={whyChooseContent.image}
              alt={whyChooseContent.imageAlt}
              className="whychoose__image"
            />
          </div>
          <ul className="whychoose__list">
            {whyChooseContent.items && whyChooseContent.items.map((item, idx) => (
              <li className="whychoose__item" key={item.title}>
                <div className="whychoose__item-content">
                  <h3 className="whychoose__item-title">{item.title}</h3>
                  <p className="whychoose__item-desc">{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
